export class GA {
    // This function sends a progress event to Google Analytics
    // when the player completes a scene.
    static sendProgressEvent(progress: string) {
        gtag('event', 'level_complete', {
            'event_category': 'progress',
            'event_label': progress,
        });
    }

    // Sends a conversion event to Google Analytics
    static sendConversion(conversion: string) {
        gtag('event', conversion);
    }

    static sendPreloadStartedEvent() {
        gtag('event', 'preload', {
            'event_category': 'started',
        });
    }
    static sendPreloadDoneEvent(value: number) {
        gtag('event', 'preload', {
            'event_category': 'ended',
            'event_label': 'duration',
            'value': value,
        });
    }
}
